
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 280 500"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('path',{attrs:{"fill":"none","d":"M0 0h280v500H0z"}})])]),_c('g',{attrs:{"clip-path":"url(#clip-path)","id":"subCard2","data-name":"Vrstva 3"}},[_c('path',{attrs:{"fill":"#00213d","d":"M-305.74 0h800v500h-800z"}}),_c('path',{attrs:{"id":"transformEl2","d":"M282.5 18.44L204.59 155.7c-5.34 10.13-9.77 25.67-6.24 41.43a56.5 56.5 0 0010 21.08c15.41 21.57 105.86 133 230.8 284.06 23.38 21 51.2 19.82 60.71 7.76v-33.29z","fill":"#0092ff"}}),_c('path',{attrs:{"id":"transformEl","d":"M-1.88 79.91c14.07 14.24 139.56 137.4 183.93 214.73 13.5 23.53 18.75 63.48 4.7 96.22-7.62 17.75-19.55 28.59-26.63 34.39q-94.3 77.34-188.63 154.66h-286.57v-500z","fill":"#00317f"}})])])
          )
        }
      }
    